import type { Paragraph } from '@/api/types/stowed-element'
import { DEFAULT_POINT_SIZE } from '@/lib/text/constants/text-defaults'

/** Point size of the first text run that sets one, or `DEFAULT_POINT_SIZE` when none does. */
export function resolveFirstRunPointSize(paragraphs: Paragraph[] | undefined): number {
  let current = DEFAULT_POINT_SIZE

  scan: for (const para of paragraphs ?? []) {
    for (const line of para.textLines ?? []) {
      for (const run of line.textRuns ?? []) {
        if (typeof run.pointSize === 'number') {
          current = run.pointSize
          break scan
        }
      }
    }
  }

  return current
}
